import { evSlugs } from '@energy-retailer/constants';

export const getIsEvPlan = (slug: string | null): boolean => {
  if (!slug) {
    return false;
  }

  if (evSlugs.includes(slug)) {
    return true;
  }

  return false;
};
